module.exports = __webpack_public_path__ + "img/qrcode.fa351798.jpeg";